<template>
  <div id="WelcomeReferral">
    <div class="logoContainer">
      <img class="top-logo" :src="getLogo" alt="company logo" />
    </div>
    <div class="wrapper">
      <h1 class="title">
        Hey {{ getUserFirstName }}, welcome to
        <span class="brand-primary">Spectrum.Life!</span>
      </h1>
      <p class="paragraph">
        Based on your referral from
        <span class="client-name">{{ getClient }}</span
        >, we have recommended that you see one of our specialists.
      </p>
      <p class="paragraph">
        You can organise a consultation with us quickly and easily! You can sign
        into your account here.
      </p>
      <b-button
        type="button"
        @click="handleClick"
        class="sign-in-button bg-brand-primary"
        variant="cta"
        ><span></span>
        <span class="button-text">
          <b-spinner v-if="isGettingReferralLoading"></b-spinner>
          <span v-else>{{isUserRegistered ? "Sign In" : "Sign Up Here"}}</span>
        </span>
        <i class="fa fa-arrow-right brand-primary" aria-hidden="true"></i>
      </b-button>
    </div>
    <div class="background-container"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import config from "../config/constants";

export default {
  name: "WelcomeReferral",
  data() {
    return {
      defaultLightLogo: "/img/spectrum_life_logo_light.png",
      referral: null,
      referralData: null,
      isGettingReferralLoading: false,
      referralCode: null
    };
  },
  computed: {
    ...mapGetters(["client"]),
    getUserFirstName() {
      return this.referralData ? this.referralData.first_name : null;
    },
    getClient() {
      return this.referralData ? this.referralData.client_name : null;
    },
    getLogo() {
      return this.defaultLightLogo;
    },
    isUserRegistered() {
      return this.referralData && this.referralData.core_user_id;
    }
  },
  mounted() {
    this.referralCode = this.$route.params.code || this.$route.query.code;
    this.$store.dispatch("logout");

    try {
      const decoded = atob(this.referralCode);

      this.referral = JSON.parse(decoded);
      this.getReferral()
    } catch (err) {
      console.error("Invalid referral code", err);
    }
  },
  methods: {
    handleClick() {
      // Mobile app deep link for referral flow
      const deepLink = `spectrum://mobile/referral/${this.referralCode}`;
      
      // Attempt to open the deep link
      try {
        window.location.href = deepLink;
      } catch (err) {
        // Fallback to web navigation
        console.error("Error opening mobile deep link", err);
      }
      
      // Set a timeout to continue with web navigation (if the app didn't open or is not installed)
      setTimeout(() => {
        // Continue with web navigation
        this.$router.push(this.isUserRegistered && this.referralData?.organisation_code ? `/login?referral=${this.referralCode}` : `/login?org=${this.referralData?.organisation_code}&referral=${this.referralCode}`);
      }, 500);
    },
    async getReferral() {
      this.isGettingReferralLoading = true
      try {
        const payload = {"referral_id": this.referral.referral_id}
        const res = await axios.post(
          config.api_env + "/application/api/sf/referral/get-referral",
          payload,
          config.options
        );
        if (res.data.success && res.data.referral) {
          this.referralData = res.data.referral;
          localStorage.setItem('referral', JSON.stringify(this.referralData));
        } else if (res.data.err) {
          console.error(err)
        }
      } catch(err) {
        console.error(err)
      } finally {
        this.isGettingReferralLoading = false
      }
    }
  }
};
</script>

<style>
#WelcomeReferral {
  position: relative;
  height: 100%;
  background-color: #fff;

  .wrapper {
    padding: 80px 100px;
    position: relative;
    z-index: 100000;
  }

  .logoContainer {
    max-width: 240px;
    padding: 40px 36px 24px;
  }

  .top-logo {
    width: 100%;
  }

  .background-container {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 50%;
    height: 100%;
    background: top center no-repeat url("https://spectrum-life-media.s3.eu-west-1.amazonaws.com/assets/art-spectrum-06-rgb-1.png");
    background-size: cover;
  }

  .title {
    font-family: "Raptor V3 Black";
    max-width: 680px;
    font-size: 6.4rem;
    color: #1f1e1e;
    text-align: left;
    margin-bottom: 40px;
  }

  .paragraph {
    max-width: 620px;
    color: #1f1e1e;
    font-family: "DMSans";
    font-size: 2.4rem;
    text-align: left;
    padding: 0;
    margin: 0;
  }

  .sign-in-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px !important;
    height: auto !important;
    min-width: 248px;
    border-radius: 5px;
    margin-top: 60px;
    .button-text {
      font-family: "Raptor V3 Black";
      font-size: 2rem;
    }
    .fa-arrow-right {
      font-size: 2.5rem;
      background-color: #fff;
      border-radius: 5px;
      padding: 10px;
    }
  }

  .client-name {
    text-transform: uppercase;
  }
}

@media only screen and (max-width: 768px) {
  #WelcomeReferral {
    .title {
      font-size: 2.4rem;
    }

    .paragraph {
      font-size: 2rem;
    }

    .wrapper {
      padding: 20px 40px;
    }
  }
}
</style>
